export class GenericFiltrationContract{
    
    parentContentId: number;
    pageIndex: number;
    pageSize: number;    
    imageSize: string;
    stringLength: number;
    citiesIds: number[];
    dynastiesIds: number [];
    searchText: string;
    isEshop:boolean;
    productKey:string
    constructor(parentId=-1, pageIndex = 1, pageSize = 10, imageSize = "", stringLength = null, searchText = "") {
        this.parentContentId = parentId;
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
        this.imageSize = imageSize;
        this.stringLength = stringLength;
        this.citiesIds=new Array();
        this.dynastiesIds=new Array();
        this.searchText = searchText;
    }


}